import React, { lazy, useEffect } from "react";
import { RouteProps } from "react-router-dom";
import { vyuMenu } from "../menu";
import Login from "../pages/presentation/auth/Login";
import { demoPagesMenu } from "../menu";
import store from "../store/store";
import Preview2 from "../pages/presentation/widgets/Preview2";
import ListCommonComponent from "../pages/presentation/common-component/listCommonComponent";
import EmployeePage from "../pages/presentation/appointment/EmployeePage";
import EditQuery from "../pages/presentation/query-tool/EditQuery";
import VyuGPT from "../pages/presentation/vyu-gpt/VyuGPT";

let tabData = store.getState();
store.subscribe(() => {
  if (store.getState().apiDashboardForUserId.apiStatus === "succeeded") {
    tabData = store.getState();
  }
});

const TABS = {
  TAB: lazy(() => import("../pages/_common/tabs")),
};

const AUTH = {
  PAGE_404: lazy(() => import("../pages/presentation/auth/Page404")),
};

const dashboards: RouteProps[] = [
  /**
   * Landing
   */
  {
    path: "/dashboard",
    element: <TABS.TAB data={tabData.apiDashboardForUserId.dashboardData} />,
  },
  {
    path: vyuMenu.queryTool.path,
    element: <ListCommonComponent component={"queryTool"} />,
  },
  {
    path: vyuMenu.widgets.path,
    element: <ListCommonComponent component={"widget"} />,
  },
  {
    path: vyuMenu.datasources.path,
    element: <ListCommonComponent component={"DataSource"} />,
  },
  {
    path: vyuMenu.mapping.path,
    element: <ListCommonComponent component={"mapping"} />,
  },
  {
    path: vyuMenu.roles.path,
    element: <ListCommonComponent component={"Roles"} />,
  },
  {
    path: vyuMenu.groups.path,
    element: <ListCommonComponent component={"Groups"} />,
  },
  {
    path: vyuMenu.vyuGPT.path,
    element: <ListCommonComponent component={"vyuGPT"} />,
  },
  {
    path: vyuMenu.reportGrid.path,
    element: <ListCommonComponent component={"reportGrid"} />,
  },
  {
    path: "//preview",
    element: <Preview2 />,
  },
  /**
   * Auth Page
   */
  {
    path: demoPagesMenu.page404.path,
    element: <AUTH.PAGE_404 />,
  },
  {
    path: demoPagesMenu.login.path,
    element: <Login />,
  },
  {
    path: demoPagesMenu.signUp.path,
    element: <Login isSignUp />,
  },
  {
    path: `/profile`,
    element: <EmployeePage />,
  },
  {
    path: `/edit-query/:queryID`,
    element: <EditQuery />,
  },
];

const Tabs = [...dashboards];
export default Tabs;
